import { focusNextOnEnter } from "../components/dataentry/entryHelpers";

// Form klavye gezintisi: Ctrl/Cmd+Enter → kaydet, Enter → sonraki alan (textarea/buton/aranabilir seçim hariç)
export function formKeyNav(e) {
  if (e.key !== "Enter") return;
  if (e.ctrlKey || e.metaKey) { e.preventDefault(); e.currentTarget.requestSubmit(); return; }
  focusNextOnEnter(e);
}

// <form> olmayan kapsayıcılar için: Ctrl/Cmd+Enter verilen kaydet fonksiyonunu çağırır
export const formKeyNavWith = (onSave) => (e) => {
  if (e.key !== "Enter") return;
  if (e.ctrlKey || e.metaKey) { e.preventDefault(); onSave?.(); return; }
  focusNextOnEnter(e);
};
